import React, { ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import useStylesHeaderSubmenuHelper from './header-submenu-helper.styles';

const HeaderSubmenuHelper: ReactMemoComponent = React.memo((): ReactElement => {
  const { classes } = useStylesHeaderSubmenuHelper();

  return (
    <FlexContainer className={classes.headerSubmenuHelper} />
  );
});

export default HeaderSubmenuHelper;
